/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export const OTEL_PATCHED_SYMBOL = Symbol.for('opentelemetry.patched');

export const OTEL_GRAPHQL_DATA_SYMBOL = Symbol.for(
  'opentelemetry.graphql_data'
);
